import { observer } from 'mobx-react';
import React, { SyntheticEvent, useEffect, useRef, useState } from 'react';
import toast from 'react-hot-toast';
import { FormattedMessage } from 'react-intl';
import SlidingPanel from 'react-sliding-side-panel';
import noMessageIcon from '../../assets/Images/no-kishu.png';
import { ModuleType } from '../../constants/enums/module-type-enum';
import userSettingEnum from '../../constants/enums/user-setting-enum';
import { GridRemoteConstant } from '../../constants/grid-constant';
import { useStore } from '../../contexts/store-provider';
import {
  KishuDefaultSortColumnOrder,
  KishuFilterInitialState,
} from '../../core/initialState/filter-initial-state';
import {
  isOperationPermittedRoleBase,
  showIconsRoleBase,
} from '../../helpers/action-permission-helper';
import { getTenantIdFromLocalStorage } from '../../helpers/localstorage-helper';
import IPageInfo, {
  IActionFormatter,
  IPageLimitInfo,
} from '../../models/ICommon';
import IDefaultColumSortOrder from '../../models/IDefaultColumSortOrder';
import { IKishuFilter } from '../../models/IKishuFilter';
import FormLoader from '../../shared-components/FormLoader/FormLoader';
import Grid from '../../shared-components/Grid/Grid';
import { CustomActionFormatter } from '../../shared-components/Grid/GridFormatter';
import Pagination from '../../shared-components/Grid/Pagination';
import Header from '../../shared-components/header/header';
import FilterPopupHOC from '../../shared-components/hoc/filter-popup-hoc/filter-popup-hoc';
import DeletePopup from '../../shared-components/popup/delete/delete-popup';
import DeletePopupHOC from '../../shared-components/popup/delete/delete-popup-hoc';
import {
  CloseSidePanelIcon,
  DeleteIcon,
  EditIcon,
  PlusIcon,
  RefreshIcon,
} from '../../shared-components/svgs/svgs';
import { formatMessage } from '../../translations/format-message';
import AddEditKishuMark from './components/add-edit-kishu-mark';
import AddKishuPopupHOC from './hoc/add-kishu-mark-popup-hoc';
import KishuMarkDetails from './kishu-mark-details';

const KishuMark = (props: any) => {
  const { kishuMarkStore, preferencesStore } = useStore();
  const {
    GetKishuListService,
    allKishu,
    kishuList,
    deleteKishuState,
    DeleteKishuService,
    resetDeleteKishu,
    resetKishuDetail,
    addUpdateKishuState,
    resetAddUpdateKishuState,
    kishuState,
    getAllKishuState,
  } = kishuMarkStore;

  const {
    userSetting,
    setUserSetting,
    language,
    islanguageChanged,
    updateLanguageChangedFlag,
  } = preferencesStore;

  let lang: string;
  const allKishuListData = allKishu;
  const isFirstLoad = useRef(true);
  const [disablePagination, setDisablePagination] = useState<boolean>(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [selectedId, setSelectedId] = useState(0);
  const [openPanel, setOpenPanel] = useState(false);
  const [isFilterCleared, setIsFilterCleared] = useState(true);
  const [columSortOrder, setColumnSortOrder] = useState<IDefaultColumSortOrder>(
    KishuDefaultSortColumnOrder
  );
  const [filterObj, setFilterObj] = useState<IKishuFilter>(
    KishuFilterInitialState
  );
  const pageLimitOptions: Array<number> = [10, 20, 50, 100];

  const [pageLimitInfo, setPageLimit] = useState<IPageLimitInfo>({
    pageLimit: userSetting.pageLimitConfig,
    isPageLimitChange: false,
  });

  const [pageInfo, setPageInfo] = useState<IPageInfo>({
    currentPage: 1,
    totalPages: 1,
    isPagerChange: false,
    isRefreshPage: false,
  });

  const onPageChanged = (pageNumber: number) => {
    setPageInfo({ ...pageInfo, currentPage: pageNumber, isPagerChange: true });
  };

  const setIsRefreshPage = () => {
    setPageInfo({ ...pageInfo, isRefreshPage: false });
  };

  const onPageLimitChanged = (evt: any) => {
    let pages: number;
    pages = props.data && Math.ceil(props.data.length / evt.target.value);
    setPageInfo({
      ...pageInfo,
      currentPage: 1,
      totalPages: pages,
      isPagerChange: false,
    });
    setPageLimit({
      pageLimit: parseInt(evt.target.value),
      isPageLimitChange: true,
    });
    setUserSetting(userSettingEnum.UserLimitConfig, parseInt(evt.target.value));
  };

  const getKishuListServiceHandler = (filterQuery?: string) => {
    if (!filterQuery) {
      filterQuery = createQueryString({
        ...filterObj,
        Column: columSortOrder.dataField,
        Order: columSortOrder.order,
      });
    }
    GetKishuListService(
      Number(getTenantIdFromLocalStorage()),
      pageInfo.currentPage,
      pageLimitInfo.pageLimit
    );
  };

  useEffect(() => {
    getKishuListServiceHandler();
  }, []);

  useEffect(() => {
    if (islanguageChanged) {
      updateLanguageChangedFlag();
    }
  }, [islanguageChanged]);

  useEffect(() => {
    setPageInfo({
      ...pageInfo,
      currentPage: kishuList?.PagingDetails?.CurrentPage,
      totalPages: kishuList?.PagingDetails?.TotalPages,
      isPagerChange: false,
    });
    setDisablePagination(false);
  }, [kishuList]);

  useEffect(() => {
    if (pageInfo.isPagerChange) {
      getKishuListServiceHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageInfo.currentPage]);

  useEffect(() => {
    if (pageLimitInfo.isPageLimitChange) {
      getKishuListServiceHandler();
      setPageLimit({ ...pageLimitInfo, isPageLimitChange: false });
    }
  }, [pageLimitInfo.pageLimit]);

  useEffect(() => {
    if (lang && language !== lang) {
      getKishuListServiceHandler();
    }
  }, [language]);

  useEffect(() => {
    if (addUpdateKishuState.success) {
      resetAddUpdateKishuState();
      getKishuListServiceHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addUpdateKishuState.success]);

  useEffect(() => {
    if (deleteKishuState.success) {
      toast.success(formatMessage('deleted_success'));
      props.deletePopupToggleHandler();
      resetDeleteKishu();
      getKishuListServiceHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteKishuState.success]);

  function rowClassFormat(row: any, rowId: number) {
    let className: string = '';
    if (selectedRow?.Id && row.Id === selectedRow.Id) {
      className = 'bg-row SelectedRow';
    }
    return className;
  }

  const rowEvents = (e: SyntheticEvent, row: any) => {
    setSelectedRow(row);
    if (selectedRow.Id === undefined || selectedRow.Id !== row.Id) {
      setOpenPanel(true);
    } else {
      setOpenPanel(!openPanel);
    }
  };

  const closePanelHandler = () => {
    setSelectedRow({});
    setOpenPanel(false);
  };

  const refreshClickHandler = () => {
    getKishuListServiceHandler();
    closePanelHandler();
  };

  const deleteHandler = () => {
    DeleteKishuService(Number(getTenantIdFromLocalStorage()), selectedId);
  };

  const deleteClickHandler = (
    row: any,
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    setSelectedId(row.Id);
    event.stopPropagation();
    closePanelHandler();
    resetKishuDetail();
    props.deletePopupToggleHandler();
  };

  const openAddKishuHandler = (
    row: { Id: number },
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    event.stopPropagation();
    closePanelHandler();
    resetKishuDetail();
    setSelectedId(row.Id);
    props.addToggleHandler();
  };

  const createQueryString = (filter: IKishuFilter): string => {
    return Object.entries(filter)
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
      .join('#');
  };

  const filterHandler = (object: IKishuFilter) => {
    const filters = {
      ...object,
      Column: columSortOrder.dataField,
      Order: columSortOrder.order,
    };
    const filter = createQueryString({ ...filters });
    getKishuListServiceHandler(filter);
    setFilterObj({ ...filters });
    props.filterPopupToggleHandler();
    closePanelhandler();
    setIsFilterCleared(false);
  };

  const closePanelhandler = () => {
    setSelectedRow({});
    setOpenPanel(false);
  };

  const filterParams = (obj: IKishuFilter, isfilterCleard: boolean) => {
    const filter = createQueryString({
      ...obj,
      Column: columSortOrder.dataField,
      Order: columSortOrder.order,
    });

    if (isfilterCleard) {
      setFilterObj({ ...obj });
      getKishuListServiceHandler(filter);
      closePanelhandler();
      setIsFilterCleared(true);
    } else {
      setFilterObj({ ...obj });
    }
    props.filterPopupToggleHandler();
  };

  const handleTableChange = (type: any, newState: any) => {
    if (isFirstLoad.current) {
      isFirstLoad.current = false;
      return;
    }

    setColumnSortOrder((prevState) => ({
      ...prevState,
      dataField: newState.sortField,
      order: newState.sortOrder,
    }));
  };

  const actionIcons: IActionFormatter[] = showIconsRoleBase(
    [
      {
        dataField: 'isEdit',
        handler: openAddKishuHandler,
        icon: <EditIcon />,
        isDisable: !isOperationPermittedRoleBase(
          ModuleType.KishuManagement,
          'Edit'
        ),
        title: 'edit',
        varient: 'primary',
        action: 'edit',
      },
      {
        dataField: 'isDelete',
        handler: deleteClickHandler,
        icon: <DeleteIcon />,
        isDisable: !isOperationPermittedRoleBase(
          ModuleType.KishuManagement,
          'Delete'
        ),
        title: 'delete',
        varient: 'danger',
        action: 'delete',
      },
    ],
    ModuleType.KishuManagement
  );

  const columns: any = [
    {
      dataField: 'serialNumber',
      text: formatMessage('serial_number'),
      classes: 'show-Elipses',
      isDummyField: true,
      formatter: (_: any, __: any, rowIndex: number) => rowIndex + 1,
      sort: false,
    },
    {
      dataField: 'Id',
      text: formatMessage('label_id'),
      classes: 'show-Elipses',
      hidden: true,
    },
    {
      dataField: 'Kishu',
      text: formatMessage('kishu'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell.length > 10 ? cell : undefined;
      },
      // sort: true,
    },
    {
      dataField: 'KishuMark',
      text: formatMessage('kishu_mark'),
      classes: 'kishuType',
      formatter: (cell: any, row) => {
        // return kishuMarkOptions.filter((k) => k.id === Number(cell))[0].value;
        return cell;
      },
      title: (cell: string) => {
        return cell.length > 10 ? cell : undefined;
      },
      // sort: true,
    },
    {
      dataField: 'Remarks',
      text: formatMessage('remarks'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell.length > 10 ? cell : undefined;
      },
    },
    {
      dataField: '',
      formatter: CustomActionFormatter(actionIcons),
      text: formatMessage('actions'),
      classes: 'last-column',
      hidden: actionIcons.length > 0 ? false : true,
    },
  ];

  return (
    <>
      {props.showAddKishuPopup && (
        <AddEditKishuMark
          id={selectedId}
          modalClosed={props.addToggleHandler}
        />
      )}
      {props.showDeletePopup && (
        <DeletePopup
          title="delete_kishu"
          modalSubmit={deleteHandler}
          modalClosed={props.deletePopupToggleHandler}
          message="message_delete_kishu_confirm"
          isLoading={deleteKishuState.inProgress}
        />
      )}
      <div className="icon-nav navbar-fixed-top device-nav-bar userTopNav">
        <div className="row align-items-center">
          <Header className='col-lg-6 col-md-6 col-sm-6' label="kishu_title" />
          <div className="col-lg-6 col-md-6 col-sm-6">
            <ul className="add-list">
              {/* <li>
                <FilterComponent
                  initialValues={filterObj}
                  id={0}
                  submitHandler={filterHandler}
                  filterParmas={filterParams}
                  onModalClosed={props.filterPopupToggleHandler}
                  isFilterCleared={isFilterCleared}
                  isLoading={false}
                  isDisable={false}
                />
              </li> */}
              <li title={formatMessage('refresh')}>
                <a
                  data-toggle="modal"
                  className="btn btn-light"
                  onClick={() => refreshClickHandler()}
                >
                  <RefreshIcon />
                </a>
              </li>
              {isOperationPermittedRoleBase(
                ModuleType.KishuManagement,
                'Add'
              ) && (
                <li title={formatMessage('add_kishu')}>
                  <a
                    className="btn btn-secondary"
                    data-toggle="modal"
                    data-testid="modalbtn"
                    data-target="#addUser"
                    onClick={(event: any) =>
                      openAddKishuHandler({ Id: -1 }, event)
                    }
                  >
                    <span className="me-1">
                      {' '}
                      <PlusIcon />
                    </span>
                    <FormattedMessage id="add_kishu" />
                  </a>
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>
      <div className={`${openPanel ? 'panelOpen' : ''}`}>
        <div className="card card-page">
          {(getAllKishuState.inProgress ||
            kishuState.inProgress ||
            deleteKishuState.inProgress) && (
            <FormLoader
              loading={
                getAllKishuState.inProgress ||
                kishuState.inProgress ||
                deleteKishuState.inProgress
              }
            />
          )}
          {allKishuListData && allKishuListData.length > 0 ? (
            <>
              <div>
                <div className="tableDesign row-eq-height tableDevices p-3 changingPanel">
                  <div
                    className="table-responsive"
                    data-testid="table"
                  >
                    {allKishuListData && (
                      <Grid
                        data={allKishuListData}
                        columns={columns}
                        keyField="Id"
                        loading={false}
                        rowClasses={rowClassFormat}
                        rowEvents={{ onClick: rowEvents }}
                        hover={true}
                        sort={{ ...columSortOrder }}
                        remote={{ ...GridRemoteConstant }}
                        onTableChange={handleTableChange}
                      />
                    )}
                  </div>
                </div>
              </div>
              {allKishuListData.length > 0 ? (
                <div className="row no-gutters p-3 pt-0 tableFooter">
                  <div className="col-lg-3 col-md-6 col-sm-6 pt-1">
                    <FormattedMessage id="show" />
                    <select
                      data-testid="pageSelect"
                      className="pageLimit"
                      onChange={onPageLimitChanged}
                      value={pageLimitInfo.pageLimit}
                    >
                      {pageLimitOptions.map((op: any) => (
                        <option
                          key={op}
                          value={op}
                        >
                          {op}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-lg-9 col-md-6 col-sm-6 d-flex justify-content-sm-end">
                    <Pagination
                      isRefreshPage={false}
                      totalPages={pageInfo.totalPages}
                      pageLimit={pageLimitInfo.pageLimit}
                      onPageChanged={onPageChanged}
                      disablePagination={disablePagination}
                      setIsRefreshPage={setIsRefreshPage}
                      currentPage={pageInfo.currentPage}
                      totalRecords={kishuList.PagingDetails.TotalRecords}
                    />
                  </div>
                </div>
              ) : (
                ''
              )}
            </>
          ) : (
            <div className="message">
              <div className="d-flex message-area">
                <div className="no-data-img">
                  <img
                    src={noMessageIcon}
                    alt=""
                    className="no_message"
                  />
                </div>
                <div>
                  <h3 className="fw-bold display-6">
                    {' '}
                    <FormattedMessage id="no_kishu" />
                  </h3>
                  <h4 className="mb-3">{formatMessage('no_kishu_message')}</h4>
                  {isOperationPermittedRoleBase(
                    ModuleType.KishuManagement,
                    'Add'
                  ) && (
                    <>
                      <a
                        className="btn btn-primary"
                        onClick={(event: any) =>
                          openAddKishuHandler({ Id: -1 }, event)
                        }
                      >
                        <span className="me-1">
                          {' '}
                          <PlusIcon />
                        </span>
                        <FormattedMessage id="add_kishu" />
                      </a>
                    </>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <SlidingPanel
        type={'right'}
        isOpen={openPanel}
        noBackdrop={false}
        size={100}
      >
        <div className="bg_slide panel">
          <div className="row bb p-2 pl-4 g-0 align-items-center ">
            <div className="col-lg-10 col-md-10 col-sm-10 col-xs-10">
              <h2 className="fw-bold mb-0 mt-1 ms-2 py-2">
                {selectedRow.Kishu}
              </h2>
            </div>
            <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2 close-icon-detail">
              <span title={formatMessage('close')}>
                <CloseSidePanelIcon closePanelHandler={closePanelHandler} />
              </span>
            </div>
          </div>
          <div className="group_detailsWrapper pb-3">
            <KishuMarkDetails selectedRowId={selectedRow.Id} />
          </div>
        </div>
      </SlidingPanel>
    </>
  );
};

export default FilterPopupHOC(
  AddKishuPopupHOC(DeletePopupHOC(observer(KishuMark)))
);
